__turbopack_context__.v({
  "button": "SuccessModal-module__PpINDq__button",
  "buttons": "SuccessModal-module__PpINDq__buttons",
  "description": "SuccessModal-module__PpINDq__description",
  "discord": "SuccessModal-module__PpINDq__discord",
  "discordIcon": "SuccessModal-module__PpINDq__discordIcon",
  "icon": "SuccessModal-module__PpINDq__icon",
  "root": "SuccessModal-module__PpINDq__root",
  "title": "SuccessModal-module__PpINDq__title",
  "twitterIcon": "SuccessModal-module__PpINDq__twitterIcon",
});
